module.exports = __webpack_public_path__ + "media/images/flags/XK-8650daa35c972601a0b87d4f37abb1b7.svg";